import { plural } from "@magnit/core/src/utilities/plural";

export const pluralGoods = (count: number) =>
  plural(count, "товар", "товара", "товаров");
